/// Mirrors the locked-columns service in the backend so the UI can dim and
/// disable inputs for fields the server refuses to update via the generic
/// PATCH endpoint.
///
/// IMPORTANT: this list is a hand-maintained mirror of
/// `crates/domain/src/firms/services/lockable_fields.rs`. Both arrays must
/// match column-for-column. Whenever the backend list changes, update this
/// file in the same commit; the locked-fields service returns 403 on any
/// drift, but the UI will misrepresent which fields are editable until the
/// mirror is fixed.
export const LOCKED_COLUMNS: ReadonlyArray<string> = [
  'id',
  'source',
  'confidence',
  'created_at',
  'updated_at',
];

/// Columns the generic PATCH accepts even though they are on the locked list.
/// Empty for firms: the firm ステータス is derived from
/// `lawyers.sales_grade` (catalog No.5/17) and `firms.sales_grade` was removed
/// in Phase 13, so there is no firm-level sales-grade carve-out anymore.
export const SERVER_EDITABLE_LOCKED_COLUMNS: ReadonlyArray<string> = [];

export function isLocked(column: string): boolean {
  return LOCKED_COLUMNS.includes(column) && !SERVER_EDITABLE_LOCKED_COLUMNS.includes(column);
}
